if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {

        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.forEach((value, key) => {
          console.log(`${key}: ${value}`);
        })
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id ));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
          config.body = formData;

          let cartModal = document.querySelector('.cart-modal');
          let cusOverlay = document.querySelector('.cus-overlay');

          let cartModalProductName = document.querySelector('#cart-modal-name');
          let cartModalProductQuantity = document.querySelector('#cart-modal-quantity');
          let cartModalProductPrice = document.querySelector('#cart-modal-price');
          let cartModalProductSize = document.querySelector('#cart-modal-size');
          let cartModalProductColor = document.querySelector('#cart-modal-color');
          let cartModalProductImage = document.querySelector('#cart-modal-img');
          
          fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            // console.log(response)
            cartModalProductName.textContent = response?.untranslated_product_title;
            cartModalProductPrice.textContent =  response?.final_line_price / 100.00;
            cartModalProductImage.src = response?.featured_image?.url;
            cartModalProductQuantity.textContent =  response?.quantity;
            
            // let transformedResponse = JSON.stringify(response)
            response.options_with_values.forEach(option => {
              let optionName = option.name.toLowerCase();
              if (optionName === 'color') {
                cartModalProductColor.textContent = option.value;
              } else if (optionName === 'size' || optionName === 'talla') {
                cartModalProductSize.textContent = option.value;
              }
            })

            cartModal.classList.toggle('hidden');
            cusOverlay.classList.toggle('hidden');
            cusOverlay.classList.toggle('forceOverlay');
            
            if (response.status) {
              
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: idVariante,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            console.log(response);
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response, true);
                    console.log({
                      "response": response,
                    })
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response, true);
              console.log({
                "response": response,
              })
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              console.log('le pone is empty');
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      ctaBtnUnsubscriber = undefined;

      connectedCallback() {
        const ctaBtnSpan = this.submitButton.querySelector('span');
        const originalTextCTA = this.submitButton.getAttribute('data-original-text');

        this.ctaBtnUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const selectedVariant = event.data.variant.option2;
            if (!selectedVariant || this.submitButton.disabled) return
            
            ctaBtnSpan.textContent = `${originalTextCTA} ${selectedVariant}`
          }
        );
      }
    }
  );
}
